import "@/i18n";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import SearchPage from "@/pages/SearchPage";
import VideoDetail from "@/pages/VideoDetail";
import CreatorPage from "@/pages/CreatorPage";
import Account from "@/pages/Account";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import SetPassword from "@/pages/SetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminVideos from "@/pages/admin/AdminVideos";
import AdminVideoEditor from "@/pages/admin/AdminVideoEditor";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminCreators from "@/pages/admin/AdminCreators";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminAsk from "@/pages/admin/AdminAsk";
import AdminEmail from "@/pages/admin/AdminEmail";
import AdminUploadTest from "@/pages/admin/AdminUploadTest";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/video/:slug" element={<VideoDetail />} />
            <Route path="/creators/:slug" element={<CreatorPage />} />
            <Route path="/account" element={<Account />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<SetPassword />} />
          <Route path="/set-password" element={<SetPassword bootstrap />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="videos" element={<AdminVideos />} />
            <Route path="videos/new" element={<AdminVideoEditor />} />
            <Route path="videos/:id" element={<AdminVideoEditor />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="creators" element={<AdminCreators />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="ask-vytali" element={<AdminAsk />} />
            <Route path="email" element={<AdminEmail />} />
            <Route path="pipeline" element={<AdminUploadTest />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
